import servicesSeoImage from "@/assets/services-seo.jpg";

const steps = [
{
  number: "01",
  title: "Kennismaken",
  description: "We bespreken je situatie en wensen. Telefonisch of via een online meeting."
},
{
  number: "02",
  title: "Plan & Offerte",
  description: "Je ontvangt een helder voorstel met wat ik ga doen, wanneer en wat het kost."
},
{
  number: "03",
  title: "Uitvoering",
  description: "Ik ga aan de slag. Je blijft op de hoogte en kunt tussentijds feedback geven."
},
{
  number: "04",
  title: "Doorlopend beheer",
  description: "Na oplevering blijf ik betrokken. Onderhoud, optimalisatie en support."
}];


export function Process() {
  return (
    <section className="section-padding gradient-bg text-white">
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Content */}
          <div>
            <p className="text-sm uppercase tracking-widest mb-4 text-white/90">Werkwijze</p>
            <h2 className="mb-6 text-white">Hoe werken we samen?</h2>
            <p className="text-white/85 mb-12">
              Geen ingewikkelde trajecten. Duidelijke stappen van eerste contact tot doorlopende samenwerking.
            </p>

            <div className="space-y-10">
              {steps.map((step, index) =>
              <div key={step.number} className="flex gap-6">
                  <div className="relative">
                    <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center text-accent-foreground font-bold">
                      {step.number}
                    </div>
                    {index < steps.length - 1 &&
                  <div className="absolute top-12 left-1/2 -translate-x-1/2 w-px h-10 bg-white/20" />
                  }
                  </div>
                  <div className="pt-2">
                    <h3 className="mb-2 text-white text-lg font-semibold">{step.title}</h3>
                    <p className="text-white/85 text-sm">{step.description}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Image */}
          <div className="hidden lg:block">
            <div className="aspect-[3/4] rounded-xl overflow-hidden sticky top-24 shadow-2xl">
              <img
                alt="Aan het werk"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
                src="/lovable-uploads/cdbd4b2a-c5ac-4048-9d7c-f1b1b7edc6a1.webp" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

}